import React from 'react'
import flexlogo from '../../assets/Logo_transparent.png'
function InputLogo({text}) {
  return (
    <>
        <img className="w-28 mx-auto" src={flexlogo} alt="Your Company"/>
        <h1 className='text-3xl text-center font-bold pb-6 pt-8'>{text}</h1>
    </>
  )
}

export default InputLogo